import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { useTransl } from 'shared/lib/i18n';

import { CLEAR_POPUP } from '../../actionConstants';

import './styles.css';

const PopupNotifications = () => {
  const { t } = useTransl();
  const dispatch = useDispatch();
  const notifications = useSelector((state) => state.notifications);

  const onOpen = useCallback(() => dispatch({ type: CLEAR_POPUP }));

  useEffect(() => {
    const { apiError, error, warning, success } = notifications || {};
    if (apiError) {
      const message = apiError || t('popup.somethingWentWrong');
      toast.error(message, { onOpen });
    }
    if (error) {
      const message = error.status || t('title.error');
      toast.error(message, { onOpen });
    }
    if (warning) {
      const message = warning.msg;
      message && toast.warn(message, { onOpen });
    }
    if (success) {
      const message = success.msg || t('status.success');
      toast.success(message, { onOpen });
    }
  }, [notifications]);

  return (
    <ToastContainer
      position="bottom-center"
      autoClose={4000}
      hideProgressBar
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable={false}
      pauseOnHover
      theme="colored"
    />
  );
};

export default PopupNotifications;
